export default __webpack_public_path__ + "static/sfe-logo-3aa5d514afa714081a0ebcc9c12336bb.svg";